import React from "react";
import { useSelector } from "react-redux";

export const usePermissions = () => {
  const { userInfo } = useSelector((state) => state.user);
  const userPermissions = React.useMemo(
    () => userInfo?.permissions || [],
    [userInfo],
  );

  const hasPermission = React.useCallback(
    (requiredPermission) => {
      return userPermissions.includes(requiredPermission);
    },
    [userPermissions],
  );

  const hasAllPermissions = React.useCallback(
    (requiredPermissions = []) => {
      if (requiredPermissions.length === 0) return true;
      return requiredPermissions.every((p) => userPermissions.includes(p));
    },
    [userPermissions],
  );

  return { userInfo, hasPermission, hasAllPermissions };
};
